import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';
import { AuthenticationService } from '../authentication/authentication.service';
import { DataStorageService } from '../dataStorage/data-storage.service';

@Injectable({
	providedIn: 'root'
})
export class BeneficiaireService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService,
		private authService: AuthenticationService,
		private dataStorageService: DataStorageService
	) {}

	beneficiaireIsyUrl = `https://pvyv02.isycare-technology.com/affectation/beneficiaire/ocashe`;

	getAllBeneficiaires(): Observable<Beneficiaire[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/all`,
			'getAllBeneficiaires',
		);
	}

	getByIntervenant(intervenantId : number): Observable<Beneficiaire[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/getByIntervenant/${intervenantId}`,
			'getByIntervenant',
		);
	}

	getByServiceAndRegion(serviceId : number, regionId : number): Observable<Beneficiaire[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/getByServiceAndRegion/${serviceId}/${regionId}`,
			'getByService',
		);
	}

	/**
	 * Renvoi la liste de tout les beneficiaires avec le minimum d'information (id, nom, prénom, care skill)
	 * @returns liste de beneficiaire
	 */
	getBeneficiairesMinimal(): Observable<Beneficiaire[]> {
		let queryParams = new HttpParams().append('light', true);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}`,
			'getBeneficiaires',
			httpOptions
		);
	}

	getByServiceAndRegionPagination(serviceId: number, regionId: number, currentPage: number, itemsPerPage: number, searchedInput?: string): Observable<any> {
			//const typeStr = selectedType.length ? selectedType.join(',') : 'ALL';
			const inputSearchStr = searchedInput.length ? searchedInput : 'NotDefined';
			return this.genericCrudService.genericGetAPIData(
				`${this.appConstants.beneficiaireUrl}/getByServiceAndRegionPagination/${serviceId}/${regionId}/${currentPage}/${itemsPerPage}/${inputSearchStr}`,
				'getByServiceAndRegionPagination'
		);
	}

	/**
	 * Renvoi la liste de tout les beneficiaires avec le minimum d'information (id, nom, prénom, care skill)
	 * @returns liste de beneficiaire
	 */
	getBeneficiairesPageable(
		page: number,
		size: number,
		search: string,
		skills: string
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}
		if (skills) {
			queryParams = queryParams.append('skill', skills);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/page`,
			'getBeneficiaires',
			httpOptions
		);
	}

	/**
	 * Renvoie un beneficiaire en fonction de l'id transmie
	 * @param id id de l'utilisateur
	 * @returns beneficiaire
	 */
	getBeneficiaireById(id: number): Observable<Beneficiaire> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/get/${id}`,
			'getBeneficiaireById'
		);
	}

	getBeneficiaireByNameAndBirthDate(firstName: string, lastName: string, birthDate: string): Observable<Beneficiaire> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/getByNameAndBirthDate/${firstName}/${lastName}/${birthDate}`,
			'getBeneficiaireByNameAndBirthDate'
		);
	}

	importBeneficiaires(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'beneficiaires.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.beneficiaireUrl}/import`,
			`importBeneficiaires`,
			formData
		);
	}

	/**
	 * Met à jour un beneficiaire
	 * @param beneficiaire
	 * @returns
	 */
	updateBeneficiaire(beneficiaire: Beneficiaire): Observable<string> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.beneficiaireUrl}/update/${beneficiaire.id}`,
			`updateBeneficiaire`,
			beneficiaire
		);
	}

	/**
	 * Sauvegarde un beneficiaire
	 * @param beneficiaire
	 * @returns
	 */
	addBeneficiaire(beneficiaire: Beneficiaire): Observable<number> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.beneficiaireUrl}/add`,
			`addBeneficiaire`,
			beneficiaire
		);
	}

	/**
	 * Supprime un beneficiaire
	 * @param beneficiaireId
	 * @returns
	 */
	deleteBeneficiaire(beneficiaireId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.beneficiaireUrl}/delete/${beneficiaireId}`,
			`deleteBeneficiaire`
		);
	}

	addBeneficiaireIsy(beneficiaire: Beneficiaire): Observable<number> {
		return this.genericCrudService.genericPostDataToAPI(
					`${this.beneficiaireIsyUrl}/post`,
					`addBeneficiaireIsy`,
					beneficiaire
				);
		
	}

	updateBeneficiaireIsy(beneficiaire: Beneficiaire): Observable<string> {
		return this.genericCrudService.genericPostDataToAPI(
					`${this.beneficiaireIsyUrl}/put`,
					`updateBeneficiaireIsy`,
					beneficiaire
				);
		
	}

	deleteBeneficiaireIsy(beneficiaireId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.beneficiaireIsyUrl}/delete/${beneficiaireId}`,
			`deleteBeneficiaire`
		);
	}
	
}
